var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '' : _b, rest = __rest(_a, ["fill"]);
    return (_jsx("svg", __assign({ id: "file", width: "24", height: "32", viewBox: "0 0 24 32", fill: fill, xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M22.8312 5.83625L18.1669 1.17125C17.4125 0.421375 16.3937 0 15.3375 0H4C1.79125 0 0 1.79063 0 4L0.00040625 28C0.00040625 30.2087 1.79103 32 4.00041 32H20C22.2 32 24 30.2 24 28V8.6625C24 7.60625 23.5812 6.5875 22.8312 5.83625ZM21 28C21 28.5522 20.5522 29 20 29H4.00125C3.449 29 3.00125 28.5522 3.00125 28L3 4.00812C3 3.45587 3.44775 3.00813 4 3.00813H14V8C14 9.10437 14.8956 10 16 10H21V28ZM13.5 13.9438C13.5 13.1688 12.8313 12.5 12 12.5C11.1687 12.5 10.5 13.1688 10.5 13.9438V17.5H7C6.17125 17.5 5.5 18.1713 5.5 18.9438C5.5 19.7725 6.17062 20.3875 7 20.3875H10.5V23.8875C10.5 24.8313 11.1687 25.5 12 25.5C12.8287 25.5 13.5 24.8287 13.5 24.0562V20.4438H17C17.8288 20.4438 18.5 19.7725 18.5 19C18.5 18.2275 17.8288 17.5562 17 17.5562H13.5V13.9438Z", fill: fill }) })));
});
